module.exports = __webpack_public_path__ + "img/ae.60a4a62f.svg";